// adapted from: https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/

import React, { createContext, useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';

export const viewportContext = createContext({});

export const ViewportProvider = ({ children }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleWindowResize = throttle(() => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    }, 50);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <viewportContext.Provider value={{ width, height }}>
      {children}
    </viewportContext.Provider>
  );
};

export const useViewport = () => {
  const { width, height } = useContext(viewportContext);
  return { width, height };
};

ViewportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
